module.exports = __webpack_public_path__ + "img/01_L1.f1cf5fb2.svg";